// Deterministic randomness shared by the Worker and the browser. Nothing in the game may call
// Math.random(): the course and every shot are pure functions of their seeds, so the server can be
// authoritative and the client can regenerate the same world from the same numbers.

/** FNV-1a 32-bit over a string. */
export function hash32(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/** mulberry32: a small, fast, seeded generator returning floats in [0, 1). */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** One seed from any number of parts, in order. */
export function seedFrom(...parts: (string | number)[]): number {
  return hash32(parts.join('|'));
}
